import i18next from 'i18next'

export const ErrorHandler = (error) => {
    const status = error?.response?.status;
  
    
    if (status === 401 || status === 403) {
      return i18next.t('VendorPopUp.Permissionlogintext');
    }
  
    //  Handle all 500 series errors
    if (status >= 500) {
      return i18next.t('VendorPopUp.Somethingwentwrong');
    }
  
    // Handle 400 errors (show BE message if safe)
    if (status === 400) {
      return (
        error?.response?.data?.message ||
        i18next.t('VendorPopUp.Invalidrequest')
      );
    }
  
    // fallback
    return i18next.t('VendorPopUp.Somethingwentwrong');
  };